import { EducatorPageChrome } from "@/pages/educators/page-chrome"
import { useId } from "react"

import { CardContent } from "@/components/ui/card"
import { PageBody } from "@/components/ui/layout"
import { SaveButton } from "@/components/shared/action-buttons"

import Form, { DetailsSection, useClassForm } from "./form"
import { useEditProps } from "./page-props"
import { useGetSpecialitiesPrewarm } from "@/api"
import { useNavigate } from "@/lib/page-rendering"

export default function Page() {
  const navigate = useNavigate()
  const {
    custom_class,
    listing_profile_id,
    listing_profile_speciality_options,
  } = useEditProps()
  const methods = useClassForm({
    defaultValues: { custom_class },
  })
  const formId = useId()
  const titleId = useId()
  useGetSpecialitiesPrewarm(
    () => new Map([[listing_profile_id, listing_profile_speciality_options]]),
    [listing_profile_id, listing_profile_speciality_options],
  )

  return (
    <>
      <EducatorPageChrome
        titleId={titleId}
        identity={
          custom_class.name === null ? undefined : { name: custom_class.name }
        }
        action={<SaveButton form={formId} />}
      />
      <PageBody>
        <CardContent>
          <Form
            formId={formId}
            labelledBy={titleId}
            onSubmit={(data) =>
              navigate({
                href: ".",
                method: "put",
                data: data,
              })
            }
            methods={methods}
          >
            <DetailsSection selectedListingProfileId={listing_profile_id} />
          </Form>
        </CardContent>
      </PageBody>
    </>
  )
}
